/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ApolloError } from 'apollo-client';
import type { IssueCreateErrorType as ErrorType } from '@jira/issue-create__issue-create-common-types/src/common/types/index.tsx';

export const handleApolloError = (error: ApolloError): ErrorType => {
	let errorType = 'unknown';
	if (error.networkError != null) {
		errorType = 'networkError';
	} else if (error.graphQLErrors && error.graphQLErrors.length > 0) {
		errorType = 'graphQLError';
	}
	// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
	return errorType;
};
